import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import helper from "./mixins/helper";
import "@mdi/font/css/materialdesignicons.css";

import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import { VsxIcon } from "vue-iconsax";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import VueSweetalert2 from 'vue-sweetalert2';
import vue3StarRatings from "vue3-star-ratings"
import 'sweetalert2/dist/sweetalert2.min.css';
import DatePicker from '@alireza-ab/vue3-persian-datepicker';
import Vuesax from 'vuesax3';
import 'vuesax3/dist/vuesax.css';
const app = createApp(App);

app.config.globalProperties.$toast = toast;
app.mixin(helper);
app.use(ElementPlus)
app.use(Vuesax, {})
app.component("vue3-star-ratings", vue3StarRatings);
app.component('DatePicker', DatePicker)
app.component("VsxIcon", VsxIcon);
app.use(PerfectScrollbarPlugin, {
    componentName: 'Scrollbar'
});
app.use(vuetify);
app.use(router);
app.use(store);
app.use(VueSweetalert2);
app.mount("#app");
